import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'add-user-mailing-list-modal',
  templateUrl: './add-user-mailing-list.component.html',
  styleUrls: ['../modal.component.scss']
})

export class AddUserToMailingListComponent implements OnInit {
  userForm: FormGroup;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.userForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      activate: false
    });
  }

  emitTrue(): void {
    this.responseChanged.emit(this.userForm.value);
  }
  
  emitFalse(): void {
    this.responseChanged.emit(null);
  }

  get f() {
    return this.userForm.controls;
  }
}